const product_loader = document.getElementById("product_loader");
const loc_url = window.location.href;

if (loc_url.includes("/account/login")) {
  document.body.classList.add("login--page");
}

if (window.location.href.includes("/cart")) {
  const productLoader = document.getElementById("product_loader");
  const lineItemTable = document.querySelector(".line-item-table__list");

  if (productLoader && lineItemTable) {
    productLoader.classList.add("loading");
    lineItemTable.classList.add("loading");

    const arePricesLoaded = () => {
      const priceElements = lineItemTable.querySelectorAll(".final_line_price");
      return Array.from(priceElements).every((el) => {
        const text = el.textContent.trim();
        return text && text !== "$0.00";
      });
    };

    const finishLoading = () => {
      lineItemTable.classList.remove("loading");
      productLoader.classList.remove("loading");
      console.log("✅ Cart fully loaded with custom prices");
    };

    // Check once immediately in case prices are already there
    if (arePricesLoaded()) {
      finishLoading();
    } else {
      // Set up mutation observer
      const observer = new MutationObserver(() => {
        if (arePricesLoaded()) {
          observer.disconnect();
          finishLoading();
        }
      });

      observer.observe(lineItemTable, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      // Optional fallback if pricing never updates (e.g. in rare edge cases)
      setTimeout(() => {
        observer.disconnect();
        finishLoading();
        console.warn("⚠️ Fallback triggered: prices not updated after 8s.");
      }, 8000);
    }
  }
}

// Reorder Functionality JS
document.addEventListener("DOMContentLoaded", async function () {
  const reorder_btn = document.querySelector(".reorder-btn");
  const product_loader = document.getElementById("product_loader");
  if (reorder_btn) {
    reorder_btn.addEventListener("click", async function () {
      product_loader.classList.add("loading");
      let orderProductsDiv = document.getElementById("order-products");
      if (!orderProductsDiv) {
        alert("No products found to reorder.");
        return;
      }

      let productsData;
      try {
        productsData = JSON.parse(
          orderProductsDiv.getAttribute("data-products")
        );
      } catch (error) {
        console.error("Error parsing JSON:", error);
        alert("Failed to retrieve order data.");
        return;
      }

      // Product and Calculator ID Mapping
      let productCalculatorMapping = {
        7631457058864: "2246e6a589f44",
        7632107601968: "5c65533f15ed4",
        7637425946672: "83c52aa8fba44",
        7637426733104: "a65f8cd0df2a4",
        7637424144432: "987b55a329814",
        7637421621296: "016bdd2bb7de4",
        7637419753520: "b8142e6f79f34",
        7637416181808: "e03778c4a1f74",
        7637413920816: "2847d3be22f44",
        7637406515248: "87c1282734d74",
        7637405204528: "c2d1e8b05ff94",
        7637404352560: "daedd20f9e3d4",
        7637399240752: "02775173e3814",
        7637393080368: "debfbd36f5ca4",
        7636684144688: "f45792e5b2e04",
        7637400617008: "73d9ae6313304",
      };

      let cartRequests = [];

      for (const product of productsData) {
        let productId = product.productId;
        let calculatorId = productCalculatorMapping[productId];

        // Skip products that are not in the mapping
        if (!calculatorId) {
          console.warn(
            `Skipping product ${product.title} (ID: ${productId}) - No calculatorId found.`
          );
          continue;
        }

        // Prepare API request data
        let requestData = {
          calculatorId: calculatorId,
          productId: productId,
          properties: product.properties,
        };

        console.log(requestData);

        try {
          // Call Appipa API to create a variant
          let response = await fetch(
            "https://api.custompricecalculator.com/api/v1/variant",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(requestData),
            }
          );

          let responseData = await response.json();
          // console.log("Variant ID: ", responseData, "Product: ", product);

          if (responseData) {
            // Prepare cart request for this variant
            cartRequests.push({
              id: responseData,
              quantity: product.quantity,
              properties: product.properties,
            });
          } else {
            console.warn(`Failed to create variant for ${product.title}`);
          }
        } catch (error) {
          console.error("Error creating variant:", error);
        }
      }

      if (cartRequests.length === 0) {
        console.log(cartRequests);
        alert("No valid products to reorder.");
        return;
      }

      // Send all items to Shopify Cart API
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: cartRequests }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Reordered successfully:", data);
          // alert("Order reordered successfully! Redirecting to cart...");
          window.location.href = "/cart";
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          alert("Failed to reorder. Please try again.");
        });
    });
  }
});

// Sticky Header Code
// window.addEventListener("scroll", () => {
//   const header = document.querySelector("store-header");
//   if (!header) return;

//   const isMobile = window.innerWidth <= 475;
//   const scrollThreshold = isMobile ? 50 : 100;

//   if (window.scrollY >= scrollThreshold) {
//     header.classList.add("header--sticky");
//   } else {
//     header.classList.remove("header--sticky");
//   }
// });

function patchMiniCartUI(cart = null) {
  console.log("🔍 patchMiniCartUI invoked");
  const cartItems = cart?.items || [];
  console.log("📦 Cart Items:", cartItems);

  cartItems.forEach((item) => {
    if (item.price > 0) {
      console.log(`✅ Skipping item ${item.id} with price ${item.price}`);
      return;
    }

    const patched = localStorage.getItem(`patched-cart-item-${item.id}`);
    if (!patched) return;

    const data = JSON.parse(patched);
    console.log(`📄 Patched Data for ${item.id} →`, data);

    let lineItem = document
      .querySelector(`a[href*="variant=${item.id}"]`)
      ?.closest("line-item");

    if (!lineItem) {
      document.querySelectorAll("line-item").forEach((li) => {
        const removeHref =
          li
            .querySelector("a[href*='/cart/change?id=']")
            ?.getAttribute("href") || "";
        const match = removeHref.match(/id=(\d+):/);
        if (match?.[1] && match[1] === String(item.id)) {
          lineItem = li;
          console.log(`🎯 Match found in remove button for variant ${item.id}`);
        }
      });
    }

    if (!lineItem) {
      console.warn(`❌ No line-item found for variant ${item.id}`);
      return;
    }

    console.log("🧱 lineItem element found:", lineItem);

    const priceEls = lineItem.querySelectorAll(
      ".line-item__price-list-container .price, .product-item-meta__price-list-container .price"
    );
    priceEls.forEach((el) => {
      console.log(`💲 Updating price for item ${item.id}`);
      el.innerHTML = `<span class="visually-hidden">Sale price</span> $${(
        data.price / 100
      ).toFixed(2)}`;
    });

    const titleEl = lineItem.querySelector(
      ".product-item-meta .product-item-meta__title"
    );
    if (titleEl && titleEl.textContent.trim() === "") {
      titleEl.textContent = data.title;
      console.log(`📝 Updating title for item ${item.id}`);
    } else {
      console.log(
        `📝 Title already exists for item ${item.id}: ${titleEl?.textContent}`
      );
    }

    const imgWrapper = lineItem.querySelector(".line-item__image-wrapper");
    const hasImg = imgWrapper?.querySelector("img");
    if (!hasImg && data.image) {
      imgWrapper.innerHTML += `<img src="${data.image}" alt="${data.title}" class="line-item__image" width="1024" height="1024" loading="lazy" />`;
      console.log(`🖼️ Injected image for item ${item.id}`);
    } else {
      console.log(`🖼️ Image already present for item ${item.id}`);
    }

    if (
      lineItem
        .querySelector(".line-item__content-wrapper")
        .classList.contains("loading")
    ) {
      lineItem
        .querySelector(".line-item__content-wrapper")
        .classList.remove("loading");
      console.log(`✅ Removed loading class for item ${item.id}`);
    }
  });

  if (document.querySelector("line-item .line-item__content-wrapper.loading")) {
    document
      .querySelector("line-item .line-item__content-wrapper.loading")
      .classList.remove("loading");
  }
  console.log("✅ patchMiniCartUI complete");
}

function observeMiniCartChanges() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) {
    console.warn("🚫 cart-drawer not found");
    return;
  }

  const observer = new MutationObserver(() => {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        patchMiniCartUI(cart);
      });
  });

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true,
  });

  console.log("👁️ MutationObserver watching cart-drawer");
}

observeMiniCartChanges();

// document.addEventListener("DOMContentLoaded", async () => {
//   const testAPIButton = document.getElementById("testAPI");
//   async function getFingerprint() {
//     const info =
//       navigator.userAgent + screen.width + screen.height + screen.colorDepth;
//     const encoder = new TextEncoder();
//     const data = encoder.encode(info);
//     const digest = await crypto.subtle.digest("SHA-256", data);
//     return Array.from(new Uint8Array(digest))
//       .map((b) => b.toString(16).padStart(2, "0"))
//       .join("");
//   }

//   async function checkSession() {
//     try {
//       const res = await fetch("https://ai.vulgrco.com/check_session", {
//         method: "GET",
//         credentials: "include",
//       });
//       if (!res.ok) {
//         console.warn("⚠️ Session check failed (probably expired).");
//         return false;
//       }
//       const data = await res.json();
//       console.log("✅ Session valid:", data.session_id);
//       return data.valid;
//     } catch (err) {
//       console.error("❌ Error checking session:", err);
//       return false;
//     }
//   }

//   async function getSession() {
//     try {
//       const res = await fetch("https://ai.vulgrco.com/get_session", {
//         method: "GET",
//         credentials: "include",
//       });
//       const data = await res.json();
//       console.log(
//         "🎟️ New session issued:",
//         data.session_id,
//         "| Issued at:",
//         data.issued_at
//       );
//     } catch (err) {
//       console.error("❌ Failed to get session:", err);
//     }
//   }

//   async function checkJobStatus(jobId) {
//     try {
//       const res = await fetch(`https://ai.vulgrco.com/status/${jobId}`, {
//         method: "GET",
//         headers: {
//           "X-API-KEY": "kaka",
//         },
//         credentials: "include",
//       });

//       if (!res.ok) {
//         const err = await res.json();
//         console.warn("⚠️ Job status failed:", err);
//         return null;
//       }

//       const data = await res.json();
//       console.log("📦 Job Status:", data);

//       return data;
//     } catch (err) {
//       console.error("❌ Error checking job status:", err);
//       return null;
//     }
//   }

//   async function waitForJob(jobId, interval = 3000) {
//     const poll = async () => {
//       const status = await checkJobStatus(jobId);
//       if (!status) return;

//       if (status.status === "finished") {
//         console.log("✅ Job completed:", status.result);
//         // ⬅️ You can show the image here or do something else with result
//       } else if (status.status === "failed") {
//         console.error("❌ Job failed");
//       } else {
//         console.log(`⏳ Job still ${status.status}...`);
//         setTimeout(poll, interval);
//       }
//     };

//     poll();
//   }

//   async function generateImage(
//     prompt = "A cute cat dancing",
//     model = "juggernaut"
//   ) {
//     const fingerprint = await getFingerprint();
//     try {
//       const res = await fetch("https://ai.vulgrco.com/generateForFrontEnd", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-API-KEY": "kaka",
//           "X-FINGERPRINT": fingerprint,
//         },
//         credentials: "include",
//         body: JSON.stringify({ prompt, model }),
//       });

//       if (!res.ok) {
//         const errData = await res.json();
//         console.warn("⚠️ Generation failed:", errData);
//         return;
//       }

//       const data = await res.json();
//       console.log("🎨 Image generation response:", data);

//       if (data.job_id) {
//         waitForJob(data.job_id); // 🔁 Start polling job status
//       }
//     } catch (err) {
//       console.error("❌ Error during image generation:", err);
//     }
//   }

//   if (testAPIButton) {
//     testAPIButton.addEventListener("click", (e) => {
//       generateImage((prompt = "A cute cat dancing"), (model = "juggernaut"));
//     });
//   }

//   // Check session on load
//   const sessionValid = await checkSession();
//   if (!sessionValid) {
//     console.log("🔁 Getting a new session...");
//     await getSession();
//   } else {
//     console.log("👍 Existing session still valid.");
//   }
// });
